import { render, staticRenderFns } from "./HomeSocial.vue?vue&type=template&id=0ca77640&"
import script from "./HomeSocial.vue?vue&type=script&lang=js&"
export * from "./HomeSocial.vue?vue&type=script&lang=js&"
import style0 from "./HomeSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports